module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-portal-3.aaea2fea.svg";